<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.affiliations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mAffiliation.nom }}
                        </h3>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.patients',1) }}:

                                        <span class="font-weight-bold">
                                {{ userInformation }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.types',1) }}:

                                        <span class="font-weight-bold">
                                {{ mAffiliation.nom }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.subscribers',1) }}:

                                        <span class="font-weight-bold">
                                {{ souscripteurInformation }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.startDate') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mAffiliation.date_debut) }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.endDate') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mAffiliation.date_fin) }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-sm-center" v-if="can">
                                <div class="card-footer text-right">
                                    <b-button variant="primary" @click="updateAffiliation">
                                        {{ $t('message.edit') }}
                                    </b-button>

                                    <b-button v-b-modal.delete-modal variant="danger">
                                        {{ $t('message.delete') }}
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.affiliations', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mAffiliation.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteAffiliation">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Affiliation",

        computed: {
            ...mapGetters(["affiliation",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mAffiliation: function() {
                return this.affiliation;
            },
            souscripteurInformation:function(){
                if (typeof this.mAffiliation.souscripteur == 'object'){
                let subscriber = this.mAffiliation.souscripteur;
                    let prenom = subscriber.prenom != null ? subscriber.prenom : "" ;
                    prenom =  prenom.toLowerCase();
                return  (subscriber.nom).toUpperCase() +" "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                }
                return  "";
            },
            userInformation:function(){
                if (typeof this.mAffiliation.user == 'object'){
                let user = this.mAffiliation.user;
                let prenom = user.prenom != null ? user.prenom : "";
                    prenom =  prenom.toLowerCase();
                return (user.nom).toUpperCase() + " "+prenom.charAt(0).toUpperCase() + prenom.substring(1);
                }
                return "";
            }
        },

        data() {
            return {
                affiliation_id: this.$route.params.affiliation,
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getUserAffiliation() {
                let args = {
                    affiliation: this.affiliation_id,
                    offset: this.offset,
                    limit: this.limit
                };
                this.$store.dispatch("getAffiliation", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY');
            },

            updateAffiliation() {
                this.$router.push({ name: 'edit-affiliation', params: { affiliation: this.affiliation_id } });
            },

            deleteAffiliation() {
                let self = this;
                let args = {
                    affiliation: this.affiliation_id
                };

                let successMessage = this.$i18n.t('message.affiliationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAffiliation', { args, index: self.affiliation_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();
                });
            }
        },

        mounted() {
            this.getUserAffiliation();
        }
    }
</script>

<style scoped>

</style>